import React from 'react';
import { includeFixedDigits } from '../../../../util/utils';
import './scoreIndex.scss';
import SCORENAME_MAPPING from '../../../../util/scorenameMapping.js';

const ScoreIndex = ({ compareItems }) => {
    const scores = Object.keys(SCORENAME_MAPPING);

    let scorebarItems;
    if (compareItems) {
        scorebarItems = scores.map((score, idx) => {
            const scorename = score;
            const propName = SCORENAME_MAPPING[score];

            let scoreHeadings = [];
            let progressBars = [];

            compareItems.forEach((item, idx) => {
                const scoreVal = includeFixedDigits(item[propName], 1);

                const heading = 
                    <div key={idx} id={idx}>
                        <span className='name'>{scorename}</span>
                        <span className='value'>{scoreVal}</span>
                    </div>;
                scoreHeadings.push(heading);

                const progressBar = <progress key={idx} id={idx} value={scoreVal} max="5"></progress>
                progressBars.push(progressBar);
            });

            return (
                <div className='container' key={idx}>
                    <div className='heading'>
                        {scoreHeadings}
                    </div>

                    <div className='progress-bars'>
                        {progressBars}
                    </div>
                </div>
            )
        });
    }

    return (
        <ul>
            {scorebarItems}
        </ul>
    );
};
export default ScoreIndex;